import { useLanguage } from "../context/LanguageContext";
import clsx from "clsx";

interface LanguageSwitcherProps {
  variant?: "menu" | "floating";
  className?: string;
}

export default function LanguageSwitcher({ variant = "menu", className }: LanguageSwitcherProps) {
  const { language, setLanguage } = useLanguage();

  const isSv = language === "sv";

  return (
    <button
      aria-label="Växla språk"
      className={clsx(
        "transition-all font-semibold px-4 py-1.5 rounded-full focus:outline-none focus:ring-2 focus:ring-[#A754FF]/70",
        isSv
          ? "bg-white/80 backdrop-blur-md text-gray-900 hover:bg-[#A754FF] hover:text-white border-2 border-[#A754FF]/30"
          : "bg-[#A754FF] text-white hover:bg-white hover:text-[#A754FF] border-2 border-[#A754FF]",
        variant === "floating"
          ? "fixed top-4 right-4 z-50 shadow-lg"
          : "shadow-glow-purple ml-4",
        className
      )}
      onClick={() => setLanguage(isSv ? "en" : "sv")}
    >
      {isSv ? "English" : "Svenska"}
    </button>
  );
} 